import {
  MeRes,
  UserDetailedRes,
  AllUserRes,
  UpdateUserReq,
  MessageRes,
  GetAllUsersParams,
  DisableUserReq,
} from './api.types';
import { apiClient } from './axios-wrapper';

const api = apiClient;

class UsersService {
  async me() {
    return await api.get<MeRes>('/users/me', { hideToast: true });
  }

  async getUserDetailed(id: number) {
    return await api.get<UserDetailedRes>(`/users/${id}/detailed`);
  }

  async getMeDetailed() {
    return await api.get<UserDetailedRes>('/users/me/detailed');
  }

  async getAllUsers(params?: GetAllUsersParams) {
    return await api.get<AllUserRes>('/users', { params });
  }

  async updateUserById(id: number, data: UpdateUserReq) {
    return await api.patch<UpdateUserReq, MessageRes>(`/users/${id}`, data);
  }

  async updateSelfUser(data: UpdateUserReq) {
    return await api.patch<UpdateUserReq, MessageRes>('/users/me', data);
  }

  async activateUser(id: number) {
    return await api.patch<never, MessageRes>(`/users/${id}/activate`);
  }

  async disableUser(id: number, data: DisableUserReq) {
    return await api.patch<DisableUserReq, MessageRes>(
      `/users/${id}/disable`,
      data
    );
  }
}

export const usersService = new UsersService();
